var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _c("div", { staticClass: "layoutTop" }),
        _vm._v(" "),
        _c(
          "b-container",
          { staticClass: "text-spacing-support", attrs: { fluid: "" } },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start" },
              [
                _c(
                  "b-col",
                  { staticClass: "showLargeScreenOnly", attrs: { md: "3" } },
                  [
                    _c(
                      "f7-button",
                      {
                        staticClass:
                          "button-action milkyBlockBlack keyboard-accessible",
                        attrs: {
                          md: "3",
                          "aria-label": _vm.$t("common.rfrsh"),
                          role: "button",
                          tabindex: "0",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onRefresh()
                          },
                          keydown: function ($event) {
                            return _vm.handleKeyDown($event, _vm.onRefresh)
                          },
                        },
                      },
                      [
                        _c("f7-icon", {
                          attrs: { f7: "refresh", "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "fab-label" }, [
                          _vm._v(_vm._s(_vm.$t("common.rfrsh"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { md: "3" } },
                  [
                    _c(
                      "f7-button",
                      {
                        staticClass:
                          "button-action milkyBlockBlack keyboard-accessible",
                        attrs: {
                          md: "3",
                          disabled: !_vm.canAddAccount(),
                          "aria-label":
                            _vm.currentType === "1"
                              ? _vm.$t("administration.company_add")
                              : _vm.$t("administration.user_add"),
                          "aria-describedby": !_vm.canAddAccount()
                            ? "add-disabled-msg"
                            : null,
                          role: "button",
                          tabindex: "0",
                        },
                        on: {
                          click: _vm.addAccount,
                          keydown: function ($event) {
                            return _vm.handleKeyDown($event, _vm.addAccount)
                          },
                        },
                      },
                      [
                        _c("f7-icon", {
                          attrs: { f7: "add", "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _vm.currentType === "1"
                          ? _c("span", { staticClass: "fab-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("administration.company_add"))
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentType === "2"
                          ? _c("span", { staticClass: "fab-label" }, [
                              _vm._v(_vm._s(_vm.$t("administration.user_add"))),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.canAddAccount()
                      ? _c(
                          "div",
                          {
                            staticClass: "sr-only",
                            attrs: { id: "add-disabled-msg" },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "administration.add_account_disabled_reason"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("b-row", [
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  {
                    staticClass: "adminUsersCompaniesListHeader",
                    attrs: {
                      role: "tablist",
                      "aria-label": "Gestion des comptes",
                    },
                  },
                  [
                    _c(
                      "f7-grid",
                      { attrs: { "no-gutter": "" } },
                      [
                        _c(
                          "f7-col",
                          {
                            staticClass: "pilotageTabController",
                            attrs: { width: "50" },
                          },
                          [
                            _c(
                              "f7-link",
                              {
                                staticClass:
                                  "pilotageLink border-top-left-radius-10px keyboard-accessible",
                                class: {
                                  tabActive: _vm.currentType === "2",
                                  tabUnactive: _vm.currentType !== "2",
                                },
                                attrs: {
                                  "tab-link": ".usersTab",
                                  active: "",
                                  role: "tab",
                                  "aria-selected": _vm.currentType === "2",
                                  "aria-controls": "users-tabpanel",
                                  tabindex:
                                    _vm.currentType === "2" ? "0" : "-1",
                                  "aria-label": _vm.$t(
                                    "administration.users_list"
                                  ),
                                  id: "users-tab",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeCurrentType("2")
                                  },
                                  keydown: function ($event) {
                                    _vm.handleKeyDown($event, function () {
                                      return _vm.changeCurrentType("2")
                                    })
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("administration.users_list")
                                    ) +
                                    "\n                  "
                                ),
                                _vm.currentType === "2"
                                  ? _c("span", { staticClass: "sr-only" }, [
                                      _vm._v(" - Onglet actif"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "f7-col",
                          {
                            staticClass: "pilotageTabController",
                            attrs: { width: "50" },
                          },
                          [
                            _c(
                              "f7-link",
                              {
                                staticClass:
                                  "pilotageLink border-top-left-radius-10px keyboard-accessible",
                                class: {
                                  tabActive: _vm.currentType === "1",
                                  tabUnactive: _vm.currentType !== "1",
                                },
                                attrs: {
                                  "tab-link": ".companiesTab",
                                  role: "tab",
                                  "aria-selected": _vm.currentType === "1",
                                  "aria-controls": "companies-tabpanel",
                                  tabindex:
                                    _vm.currentType === "1" ? "0" : "-1",
                                  "aria-label": _vm.$t(
                                    "administration.companies_list"
                                  ),
                                  id: "companies-tab",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeCurrentType("1")
                                  },
                                  keydown: function ($event) {
                                    _vm.handleKeyDown($event, function () {
                                      return _vm.changeCurrentType("1")
                                    })
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("administration.companies_list")
                                    ) +
                                    "\n                  "
                                ),
                                _vm.currentType === "1"
                                  ? _c("span", { staticClass: "sr-only" }, [
                                      _vm._v(" - Onglet actif"),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "f7-tabs",
                      [
                        _c(
                          "f7-tab",
                          {
                            staticClass: "usersTab",
                            attrs: {
                              active: "",
                              role: "tabpanel",
                              id: "users-tabpanel",
                              "aria-labelledby": "users-tab",
                              "aria-hidden": _vm.currentType !== "2",
                            },
                          },
                          [
                            _c("f7-searchbar", {
                              staticClass: "webdatalist keyboard-accessible",
                              attrs: {
                                "cancel-link": _vm.$t("common.cncl"),
                                placeholder: _vm.$t("common.search_users"),
                                "search-list": "#users-list",
                                "aria-label": _vm.$t("common.search_users"),
                                role: "searchbox",
                                "aria-describedby": "users-search-help",
                              },
                              on: {
                                "searchbar:search": _vm.onUsersSearch,
                                "searchbar:clear": _vm.onUsersClear,
                                keydown: _vm.handleSearchKeyDown,
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "sr-only",
                                attrs: { id: "users-search-help" },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("common.search_users_help")) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "itemList" },
                              [
                                _vm.usersList.length === 0
                                  ? _c("spinner")
                                  : _c("users-list", {
                                      attrs: { users: _vm.usersList },
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "f7-tab",
                          {
                            staticClass: "companiesTab",
                            attrs: {
                              role: "tabpanel",
                              id: "companies-tabpanel",
                              "aria-labelledby": "companies-tab",
                              "aria-hidden": _vm.currentType !== "1",
                            },
                          },
                          [
                            _c("f7-searchbar", {
                              staticClass: "webdatalist keyboard-accessible",
                              attrs: {
                                "cancel-link": _vm.$t("common.cncl"),
                                placeholder: _vm.$t("common.search_companies"),
                                "search-list": "#companies-list",
                                "aria-label": _vm.$t("common.search_companies"),
                                role: "searchbox",
                                "aria-describedby": "companies-search-help",
                              },
                              on: {
                                "searchbar:search": _vm.onCompaniesSearch,
                                "searchbar:clear": _vm.onCompaniesClear,
                                keydown: _vm.handleSearchKeyDown,
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "sr-only",
                                attrs: { id: "companies-search-help" },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("common.search_companies_help")
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "itemList" },
                              [
                                _vm.companiesList.length === 0
                                  ? _c("spinner")
                                  : _c("companies-list", {
                                      attrs: { companies: _vm.companiesList },
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "toolbarPageBottomBlank" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }